/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetSfUserMappings200Response } from '../models';
// @ts-ignore
import { UpsertSfUserMappingBodyRequest } from '../models';
/**
 * SfUserMappingsApi - axios parameter creator
 * @export
 */
export const SfUserMappingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Salesforceのユーザー情報
         * @summary Salesforceのユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfUserMappings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/salesforce/sf_user_mappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Salesforceのマッピングしたいオブジェクト情報
         * @summary Salesforceのマッピングしたいオブジェクト情報の更新
         * @param {UpsertSfUserMappingBodyRequest} [upsertSfUserMappingBodyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSfUserMappingBody: async (upsertSfUserMappingBodyRequest?: UpsertSfUserMappingBodyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/salesforce/sf_user_mappings/upsert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSfUserMappingBodyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SfUserMappingsApi - functional programming interface
 * @export
 */
export const SfUserMappingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SfUserMappingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Salesforceのユーザー情報
         * @summary Salesforceのユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSfUserMappings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSfUserMappings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSfUserMappings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Salesforceのマッピングしたいオブジェクト情報
         * @summary Salesforceのマッピングしたいオブジェクト情報の更新
         * @param {UpsertSfUserMappingBodyRequest} [upsertSfUserMappingBodyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertSfUserMappingBody(upsertSfUserMappingBodyRequest?: UpsertSfUserMappingBodyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertSfUserMappingBody(upsertSfUserMappingBodyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SfUserMappingsApi - factory interface
 * @export
 */
export const SfUserMappingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SfUserMappingsApiFp(configuration)
    return {
        /**
         * Salesforceのユーザー情報
         * @summary Salesforceのユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSfUserMappings(options?: any): AxiosPromise<GetSfUserMappings200Response> {
            return localVarFp.getSfUserMappings(options).then((request) => request(axios, basePath));
        },
        /**
         * Salesforceのマッピングしたいオブジェクト情報
         * @summary Salesforceのマッピングしたいオブジェクト情報の更新
         * @param {UpsertSfUserMappingBodyRequest} [upsertSfUserMappingBodyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertSfUserMappingBody(upsertSfUserMappingBodyRequest?: UpsertSfUserMappingBodyRequest, options?: any): AxiosPromise<boolean> {
            return localVarFp.upsertSfUserMappingBody(upsertSfUserMappingBodyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SfUserMappingsApi - interface
 * @export
 * @interface SfUserMappingsApi
 */
export interface SfUserMappingsApiInterface {
    /**
     * Salesforceのユーザー情報
     * @summary Salesforceのユーザー情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfUserMappingsApiInterface
     */
    getSfUserMappings(options?: AxiosRequestConfig): AxiosPromise<GetSfUserMappings200Response>;

    /**
     * Salesforceのマッピングしたいオブジェクト情報
     * @summary Salesforceのマッピングしたいオブジェクト情報の更新
     * @param {UpsertSfUserMappingBodyRequest} [upsertSfUserMappingBodyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfUserMappingsApiInterface
     */
    upsertSfUserMappingBody(upsertSfUserMappingBodyRequest?: UpsertSfUserMappingBodyRequest, options?: AxiosRequestConfig): AxiosPromise<boolean>;

}

/**
 * Request parameters for upsertSfUserMappingBody operation in SfUserMappingsApi.
 * @export
 * @interface SfUserMappingsApiUpsertSfUserMappingBodyRequest
 */
export interface SfUserMappingsApiUpsertSfUserMappingBodyRequest {
    /**
     * 
     * @type {UpsertSfUserMappingBodyRequest}
     * @memberof SfUserMappingsApiUpsertSfUserMappingBody
     */
    readonly upsertSfUserMappingBodyRequest?: UpsertSfUserMappingBodyRequest
}

/**
 * SfUserMappingsApi - object-oriented interface
 * @export
 * @class SfUserMappingsApi
 * @extends {BaseAPI}
 */
export class SfUserMappingsApi extends BaseAPI implements SfUserMappingsApiInterface {
    /**
     * Salesforceのユーザー情報
     * @summary Salesforceのユーザー情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfUserMappingsApi
     */
    public getSfUserMappings(options?: AxiosRequestConfig) {
        return SfUserMappingsApiFp(this.configuration).getSfUserMappings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Salesforceのマッピングしたいオブジェクト情報
     * @summary Salesforceのマッピングしたいオブジェクト情報の更新
     * @param {SfUserMappingsApiUpsertSfUserMappingBodyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SfUserMappingsApi
     */
    public upsertSfUserMappingBody(requestParameters: SfUserMappingsApiUpsertSfUserMappingBodyRequest = {}, options?: AxiosRequestConfig) {
        return SfUserMappingsApiFp(this.configuration).upsertSfUserMappingBody(requestParameters.upsertSfUserMappingBodyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
